export default __webpack_public_path__ + "static/media/170.8361f40e.svg";